import breadcrumbComp from "../../common/breadcrumb-comp.vue";
import EncryptUtility from "../../utility/js/encrypt-utility";
import AddFavourite from "../../utility/js/addFav";
import BackToTop from "../../common/back-to-top.vue";
import reportService from "./reports-service";       
import reportingService from "./reporting-service";  

export default {
  name: "auditWorkcenterDashboard",
  data() {
    return {
      userId: EncryptUtility.localStorageDecrypt("userID"),
      actionList: [],
      favouriteList: [],
      mainPage: "",
      subPage: "",
      backSlash: true,
      pageUrl: "",
      showAdd: false,
      refresh: true,
      selectedProject: "",
      projectList: [],
      selectedBusiness: "",
      businessList: [],
      showAllForm: false, 
      showSearch: false,   
      dashboardData: [],
      filteredDashboardData: [],
      dashboardSearchIndex: [],
      totalRecords: 0,
      searchDashboardInput: "",
      searchDashboardTimer: null,
      dashboardSearchJob: 0,
      dashboardFiltering: false,
      dashboardPage: 1,
      dashboardRowsPerPage: 50,
      showData: false,
      headerReport: [
        { text: "Project",               value: "Project",   class: "primary customwhite--text" },
        { text: "Business",              value: "Business",  class: "primary customwhite--text" },
        { text: "Currently In Audit",    value: "CurrentlyInAudit",   class: "primary customwhite--text" },
        { text: "Total Audits",          value: "TotalAudits",   class: "primary customwhite--text" },
        { text: "Pass",                  value: "Pass",      class: "primary customwhite--text" },
        { text: "Fail",                  value: "Fail",      class: "primary customwhite--text" },
      ],

      // Payload sent to the backend API (AuditWorkCenterReportModel)
      filterObj: {
        proj_key: 0,   // 0 = ALL projects
        bu_key: 0,     // 0 = ALL businesses
      },
    };
  },

  async created() {
    this.route = this.$route.path.replace("/", "");
    let data = await AddFavourite.getPageAction(this.userId, this.route);
    this.actionList    = data.actionList;
    this.mainPage      = data.mainPage;
    this.favouriteList = data.favouriteList;
    this.pageUrl       = data.pageUrl;
    this.subPage       = data.subPage;
    this.showAdd       = data.showAdd;
    this.getProjectData();
  },

  computed: {
    dashboardPageCount() {
      return Math.max(1, Math.ceil(this.filteredDashboardData.length / this.dashboardRowsPerPage));
    },
    pagedDashboardData() {
      const start = (this.dashboardPage - 1) * this.dashboardRowsPerPage;
      return this.filteredDashboardData.slice(start, start + this.dashboardRowsPerPage);
    },
  },

  watch: {
    searchDashboardInput() {
      this.dashboardPage = 1;
    },
  },

  methods: {
    addFav() {
      this.showAdd = !this.showAdd;
      AddFavourite.add_remove_Favourite(this.showAdd, this.userId, this.route);
    },

    //To bring page based actions to the page
    actionSetter(action) {
      if (this.actionList !== undefined && this.actionList !== null && this.actionList !== "") {
        let filter = this.actionList.filter((entry) => entry.SystemName === action);
        return filter !== undefined && filter !== null && filter.length == 1 ? true : false;
      } else return false;
    },

    // Load all projects and prepend an ALL option (proj_key = 0)
    async getProjectData() {
      let projData = await reportingService.getReportingGenericProjectList("get", this.userId);
      if (projData && Array.isArray(projData)) {
        this.projectList = [{ value: "ALL", value_id: 0 }, ...projData];
      }
    },

    // Project selection
    async onChangeProject() {
      this.clearDashboardSearch();
      this.selectedBusiness = "";
      this.businessList     = [];
      this.showAllForm      = false;
      this.showSearch       = false;
      this.dashboardData    = [];
      this.filteredDashboardData = [];
      this.dashboardSearchIndex = [];
      this.totalRecords     = 0;
      this.showData         = false;
      this.filterObj.bu_key = 0;

      if (parseInt(this.selectedProject) === 0) {
        this.showSearch = true;
        return;
      }

      // Specific project — load businesses for it
      let obj = { proj_key: parseInt(this.selectedProject) };
      let busData = await reportingService.getReportingGenericBusinessList("post", obj);
      if (busData && Array.isArray(busData)) {
        this.businessList = [{ value: "ALL", value_id: 0 }, ...busData];
        this.showAllForm = true;
      } else {
        let Alert = { type: "error", isShow: true, message: "No Business found for the selected Project" };
        this.$store.commit("ConfigModule/Alert", Alert);
      }
    },

    // Business selection — any choice (ALL or specific) shows Run
    onChangeBusiness() {
      this.clearDashboardSearch();
      this.dashboardData = [];
      this.filteredDashboardData = [];
      this.dashboardSearchIndex = [];
      this.totalRecords  = 0;
      this.showData      = false;
      this.showSearch    = true;
    },

    async onClickSearch() {
      this.filterObj.proj_key = parseInt(this.selectedProject) || 0;
      this.filterObj.bu_key   = parseInt(this.selectedBusiness) || 0;

      let data = await reportService.auditWorkcenterDashboard("post", this.filterObj, false);

      if (data && data.message !== "NA") {
        if (Array.isArray(data) && data.length > 0) {
          this.clearDashboardSearch();
          this.setDashboardData(data);
          this.totalRecords  = data.length;
          this.showData      = true;
        } else {
          this.dashboardData = [];
          this.filteredDashboardData = [];
          this.dashboardSearchIndex = [];
          this.totalRecords  = 0;
          this.showData      = false;
          let Alert = { type: "error", isShow: true, message: "No records found for the selected criteria" };
          this.$store.commit("ConfigModule/Alert", Alert);
        }
      }
    },

    // Reset all selections and clear the dashboard results
    resetFunction() {
      this.clearDashboardSearch();
      this.selectedProject  = "";
      this.selectedBusiness = "";
      this.projectList      = [];
      this.businessList     = [];
      this.showAllForm      = false;
      this.showSearch       = false;
      this.dashboardData    = [];
      this.filteredDashboardData = [];
      this.dashboardSearchIndex = [];
      this.totalRecords     = 0;
      this.showData         = false;
      this.filterObj = { proj_key: 0, bu_key: 0 };
      this.getProjectData();
    },

    queueDashboardSearch() {
      clearTimeout(this.searchDashboardTimer);
      this.searchDashboardTimer = setTimeout(() => {
        this.applyDashboardSearch();
      }, 150);
    },

    clearDashboardSearch() {
      clearTimeout(this.searchDashboardTimer);
      this.dashboardSearchJob++;
      this.dashboardFiltering = false;
      this.searchDashboardInput = "";
      this.filteredDashboardData = this.dashboardData;
      this.dashboardPage = 1;
    },

    setDashboardData(data) {
      this.dashboardData = data;
      this.filteredDashboardData = data;
      this.dashboardSearchIndex = data.map((item) => ({
        item,
        text: this.getDashboardSearchText(item),
      }));
      this.dashboardPage = 1;
    },

    getDashboardSearchText(item) {
      if (!item) return "";

      const projectValue = this.getDashboardFieldValue(item, [
        "Project",
        "project",
        "ProjectName",
        "project_name",
        "proj_name",
        "proj_code",
        "Project/Business",
        "projBusiness",
        "proj_business",
      ]);
      const businessValue = this.getDashboardFieldValue(item, [
        "Business",
        "business",
        "BusinessName",
        "business_name",
        "business_code",
        "BusinessCode",
        "bu_name",
        "bu_code",
        "BU",
        "BU Name",
        "lbl_BU",
        "Project/Business",
        "projBusiness",
        "proj_business",
      ]);

      return [projectValue, businessValue]
        .map((value) => (value === null || value === undefined ? "" : value.toString()))
        .join(" ")
        .toLowerCase();
    },

    getDashboardFieldValue(item, aliases) {
      if (!item || typeof item !== "object") return "";

      for (let i = 0; i < aliases.length; i++) {
        if (item[aliases[i]] !== null && item[aliases[i]] !== undefined) {
          return item[aliases[i]];
        }
      }

      const normalizedAliases = aliases.map((alias) => alias.toLowerCase().replace(/[^a-z0-9]/g, ""));
      const matchingKey = Object.keys(item).find((key) => {
        const normalizedKey = key.toLowerCase().replace(/[^a-z0-9]/g, "");
        return normalizedAliases.some((alias) => normalizedKey === alias || normalizedKey.indexOf(alias) !== -1 || alias.indexOf(normalizedKey) !== -1);
      });

      return matchingKey ? item[matchingKey] : "";
    },

    applyDashboardSearch() {
      const searchText = (this.searchDashboardInput || "").toString().trim().toLowerCase();
      const job = ++this.dashboardSearchJob;
      this.dashboardPage = 1;

      if (!searchText) {
        this.dashboardFiltering = false;
        this.filteredDashboardData = this.dashboardData;
        return;
      }

      this.dashboardFiltering = true;
      this.filteredDashboardData = [];

      const results = [];
      const chunkSize = 100;
      const index = this.dashboardSearchIndex;

      const filterChunk = (start) => {
        if (job !== this.dashboardSearchJob) return;

        try {
          const end = Math.min(start + chunkSize, index.length);
          for (let i = start; i < end; i++) {
            const searchIndexText = index[i]?.text || "";
            if (searchIndexText.indexOf(searchText) !== -1) {
              results.push(index[i].item);
            }
          }

          if (end < index.length) {
            window.setTimeout(() => filterChunk(end), 0);
            return;
          }

          if (job === this.dashboardSearchJob) {
            this.filteredDashboardData = results;
            this.dashboardFiltering = false;
          }
        } catch (error) {
          this.filteredDashboardData = [];
          this.dashboardFiltering = false;
        }
      };

      window.setTimeout(() => filterChunk(0), 0);
    },
  },

  beforeDestroy() {
    clearTimeout(this.searchDashboardTimer);
    this.dashboardSearchJob++;
  },

  components: {
    breadcrumbComp,
    BackToTop,
  },
};
